import { useParams } from "react-router";

import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";

import useTemplate from "../../Template/useTemplate";
import useTemplateDeployment from "../../TemplateDeployment/useTemplateDeployment";
import { FILTERS_ORDER_SETTINGS_KEY } from "../../TemplatesWorkbench/constants";
import { getTemplateMarketplaceTemplateUrl } from "../utils";
import PageLayout from "./PageLayout";

const TemplatesMarketplaceTemplateDeployment = () => {
  const { templateId, deploymentId } = useParams<{
    templateId: string;
    deploymentId: string;
  }>();

  const {
    error: templateError,
    loading: templateLoading,
    data: templateData,
  } = useTemplate(templateId);

  const {
    deployment,
    loading: deploymentLoading,
    error: deploymentError,
  } = useTemplateDeployment({
    templateId: templateId!,
    deploymentId: deploymentId!,
  });

  const template = templateData?.template;
  const templateUrl = getTemplateMarketplaceTemplateUrl(templateId!);

  useBreadcrumbs(
    [
      {
        title: "Templates",
        link: getBreadcrumbsBackUrl("/templates", FILTERS_ORDER_SETTINGS_KEY),
      },
      {
        title: template?.name || "",
        link: templateUrl,
      },
      {
        title: deployment?.name || "",
      },
    ],
    [template?.name, templateUrl, deployment?.name]
  );

  const templateErrorContent = useErrorHandle(templateError);
  const deploymentErrorContent = useErrorHandle(deploymentError);

  if (templateErrorContent) {
    return templateErrorContent;
  }

  if (deploymentErrorContent) {
    return deploymentErrorContent;
  }

  if ((templateLoading && !template) || (deploymentLoading && !deployment)) {
    return <PageLoading />;
  }

  if (!template || !deployment) {
    return <NotFoundPage />;
  }

  return <PageLayout template={template} deployment={deployment} />;
};

export default TemplatesMarketplaceTemplateDeployment;
